import { useMenu } from 'src/contexts/menu-context'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { trackMenuPathDesktop } from '../../../utils'
import { Basic } from './Basic'
import { WithLogo } from './WithLogo'

export const ParentItem = ({
  item,
  type,
  level,
  position,
}: ParentAndLinkItemProps) => {
  const { handleDispatch, state } = useMenu()

  const handleTrack = () => {
    trackMenuPathDesktop(Number(type), state)
  }

  return (
    <div
      key={`list-menu-item-${position}`}
      className="cursor-pointer"
      onMouseEnter={() =>
        type &&
        typeof position === 'number' &&
        typeof item.label === 'string' &&
        handleDispatch(type, position, item.label, Number(type) + 1)
      }
    >
      {item.logoImage ? (
        <WithLogo item={item} level={level} position={position} />
      ) : (
        <a
          href={item.labelURL ? item.labelURL : undefined}
          onClick={item.labelURL ? () => handleTrack() : undefined}
        >
          <Basic item={item} level={level} position={position} />
        </a>
      )}
    </div>
  )
}
